import { Controller } from '@hotwired/stimulus'
import { MutexFetcher } from 'api/mutex_fetcher'
import { Modal } from 'bootstrap'
class Meatgazers extends Controller {
  connect () {
    this.fetcher = new MutexFetcher()
  }

  show () {
    const modalElement = document.getElementById('meatgazersModal')
    if (modalElement === null) { throw new Error('No modal found') }
    this.fetcher.call({
      url: this.urlValue,
      method: 'GET',
      callback: (html) => {
        modalElement.querySelector('.modal-body').innerHTML = html
        Modal.getOrCreateInstance(modalElement).show()
      }
    })
  }
}
Meatgazers.values = { url: String }
export default Meatgazers
